export default {
	title: 'Terminal Type Management',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete {count} selected record(s)?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select the record to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		name: 'Terminal Name',
		mode: 'Communication Mode',
		placeholder: {
			name: 'Please enter terminal name',
			mode: 'Please select communication mode'
		}
	},
	table: {
		id: 'ID',
		name: 'Terminal Type Name',
		icon: 'Icon',
		mode: 'Communication Mode',
		channels: 'Channels',
                sysEig: 'Feature Values',
		sysWave: 'Waveform',
		orgId: 'Organization'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	widgetForm: {
		name: 'Name',
		icon: 'Icon',
		mode: 'Communication Mode',
		channels: 'Channels',
                characters: 'Feature Value Function Code',
		topic: 'MQTT Topic',
		accelerate: 'Time Domain Function Code',
                sysEig: 'Feature Values',
		sysWave: 'Waveform Type',
		orgId: 'Organization (Diagnosis)',
		gridLayout: 'Grid Layout',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
			name: 'Please enter name',
			icon: 'Please select icon',
			mode: 'Please select communication mode',
                        characters: 'Please enter feature value function code',
			topic: 'Please enter MQTT topic',
			accelerate: 'Please enter time domain function code',
			orgId: 'Organization (Diagnosis)'
		},
		options: {
			modeLabel: 'Label 1'
		}
	}
}
